module.exports = __webpack_public_path__ + "static/media/Activated.1a5e637a.svg";